import React, { useState } from 'react';
import RecetaMedica from '../../components/admin/RecetaMedica';
import { toast } from 'react-hot-toast';

// Importar estilos de animaciones
import '../../styles/animations.css';

const TestReceta = () => {
  const [mostrarReceta, setMostrarReceta] = useState(false);
  
  // Datos de ejemplo para pruebas
  const pacientePrueba = {
    nombre: 'Juan',
    apellido: 'Pérez',
    cedula: '1234567890',
    email: 'juan.perez@ejemplo.com',
    telefono: '0987654321'
  };
  
  const diagnosticoPrueba = 'Conjuntivitis viral. Reposo 5 días.';
  
  // Función para manejar la agenda de nueva cita
  const handleAgendarCita = async (citaData) => {
    try {
      // Simulamos la operación de agendar cita
      console.log('Datos de la cita a agendar:', citaData);
      
      // Simular una demora de red
      await new Promise(resolve => setTimeout(resolve, 800));
      
      // Simulamos éxito
      toast.success(`Cita agendada para ${citaData.fecha} a las ${citaData.hora}`);
      return Promise.resolve({ success: true });
    } catch (error) {
      console.error('Error al agendar cita:', error);
      toast.error('No se pudo agendar la cita');
      return Promise.reject(error);
    }
  };
  
  return (
    <div className="container mx-auto px-4 py-6">
      <h1 className="text-2xl font-semibold text-gray-800 mb-6">
        Prueba de Generación de Recetas
      </h1>
      
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <h2 className="text-xl font-medium text-gray-700 mb-4">
          Instrucciones
        </h2>
        
        <p className="text-gray-600 mb-4">
          Esta página permite probar la funcionalidad de generación de recetas médicas 
          utilizando la plantilla PDF configurada en el sistema. Al hacer clic en el
          botón "Generar Receta de Prueba", se mostrará el formulario para completar
          la información y generar un PDF.
        </p>
        
        <p className="text-gray-600 mb-4">
          Los datos del paciente mostrados son de prueba.
        </p>
        
        <div className="flex justify-center mt-6">
          <button
            onClick={() => setMostrarReceta(!mostrarReceta)}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md transition duration-300"
          >
            {mostrarReceta ? 'Ocultar Formulario' : 'Generar Receta de Prueba'}
          </button>
        </div>
      </div>
      
      {mostrarReceta && (
        <div className="mt-8">
          <RecetaMedica
            paciente={pacientePrueba}
            diagnostico={diagnosticoPrueba}
            proximaCita="15/04/2025"
            doctorNombre="Dra. Ximena Ríos R."
            onCancel={() => setMostrarReceta(false)}
            onAgendarCita={handleAgendarCita}
          />
        </div>
      )}
    </div>
  );
};

export default TestReceta;